<template>
	<form class="form-signup" :class="'form-signup--' + type" novalidate @submit.prevent="onSubmit">
		<div v-if="type === 'long'" class="form__inner">
			<div class="row align-items-center">
				<div class="col-12 col-lg-auto">
					<div class="form__text">
						<img class="form__logo img-fluid" src="~@/assets/logo-2.png" alt="logo" />
						<h3 class="form__title">JOIN TO OUR <span>CLUB</span></h3>
					</div>
				</div>
				<div class="col-12 col-lg">
					<div class="row">
						<div class="col-12 col-md-6">
							<label class="input-wrp">
								<input
									class="textfield"
									:class="{'__invalid': sErrorField === 'name'}"
									type="text"
									name="name"
									placeholder="First Name "
								/>

								<span v-if="sErrorField === 'name'" class="textfield-error">{{ sErrorMessage }}</span>
							</label>
						</div>

						<div class="col-12 col-md-6">
							<label class="input-wrp">
								<input
									class="textfield"
									:class="{'__invalid': sErrorField === 'email'}"
									type="text"
									name="email"
									placeholder="E-mail"
									inputmode="email"
									x-inputmode="email"
								/>

								<span v-if="sErrorField === 'email'" class="textfield-error">{{ sErrorMessage }}</span>
							</label>
						</div>

						<div class="col-12">
							<label
								class="checkfield"
								:class="{'__invalid': sErrorField === 'agree'}"
							>
								<input
									type="checkbox"
									name="agree"
								/>
								<i></i>
								<span>I agree with License agreement</span>
								<span v-if="sErrorField === 'agree'" class="textfield-error">{{ sErrorMessage }}</span>
							</label>

							<button type="submit" class="custom-btn form__submit">Join us</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="form__inner">
			<h3 class="form__title">JOIN TO OUR <span>CLUB</span></h3>

			<label class="input-wrp">
				<input
					class="textfield"
					:class="{'__invalid': sErrorField === 'name'}"
					type="text"
					name="name"
					placeholder="First Name "
				/>

				<span v-if="sErrorField === 'name'" class="textfield-error">{{ sErrorMessage }}</span>
			</label>

			<label class="input-wrp">
				<input
					class="textfield"
					:class="{'__invalid': sErrorField === 'email'}"
					type="text"
					name="email"
					placeholder="E-mail"
					inputmode="email"
					x-inputmode="email"
				/>

				<span v-if="sErrorField === 'email'" class="textfield-error">{{ sErrorMessage }}</span>
			</label>

			<label
				class="checkfield"
				:class="{'__invalid': sErrorField === 'agree'}"
			>
				<input
					type="checkbox"
					name="agree"
				/>
				<i></i>
				<span>I agree with License agreement</span>
				<span v-if="sErrorField === 'agree'" class="textfield-error">{{ sErrorMessage }}</span>
			</label>

			<button type="submit" class="custom-btn form__submit">Join us</button>
		</div>
	</form>
</template>

<script>
import axios from 'axios';

export default {
	name: 'form-signup',

	props: {
		type: {
			type: String,
			default: 'short'
		}
	},

	data: function ()
	{
		return {
			sUserIP: '',

			sErrorField: '',
			sErrorMessage: ''
		}
	},

	methods: {
		onSubmit: async function ()
		{
			if (this.__loading) return;


			var nForm = this.$el,

				nName = nForm.elements.name,
				sName = nName.value,

				nEmail = nForm.elements.email,
				sEmail = nEmail.value,

				sAgree = nForm.elements.agree.value,

				rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i

			this.sErrorField = '';
			this.sErrorMessage = '';

			if (!sName)
			{
				this.sErrorField = 'name';
				this.sErrorMessage = 'This fileld is required';

				nName.focus();

				return;
			}

			if (sName.length < 3)
			{
				this.sErrorField = 'name';
				this.sErrorMessage = 'Please enter at least 3 characters';

				nName.focus();

				return;
			}

			if (!sEmail)
			{
				this.sErrorField = 'email';
				this.sErrorMessage = 'This fileld is required';

				nEmail.focus();

				return;
			}

			var isEmailValid = rEmail.test(sEmail);

			if (!isEmailValid)
			{
				this.sErrorField = 'email';
				this.sErrorMessage = 'Please, enter a valid email';

				nEmail.focus();

				return;
			}

			sEmail = encodeURIComponent(sEmail.toLowerCase());

			if (!nForm.elements.agree.checked)
			{
				this.sErrorField = 'agree';
				this.sErrorMessage = 'This fileld is required';

				return;
			}

			var sFormData = 'name=' + sName + '&email=' + sEmail +'&sign_agree=' + sAgree;


			this.__loading = true;


			if (!this.sUserIP)
			{
				this.sUserIP = await this.getIP();
			}

			var oSearchParams = new URL(document.location).searchParams;

			sFormData += '&ip=' + this.sUserIP + '&pid=' + oSearchParams.get('pid') + '&pid_sid=' + oSearchParams.get('sid');

			try
			{
				var oResp = await axios.post('/api/?action=registration', sFormData);

				this.__loading = false;

				if (oResp.data.error && oResp.data.error !== '')
				{
					var sErrorMessage = 'E-mail is already registered';

					if (oResp.data.error === sErrorMessage)
					{
						this.sErrorField = 'email';
						this.sErrorMessage = sErrorMessage;

						nEmail.focus();

						return;
					}

					alert(oResp.data.error);
				}
				else if (oResp.data.loc)
				{
					setTimeout(function()
					{
						document.location = oResp.data.loc;
					}, 500);
				}
			}
			catch (e)
			{
				this.__loading = false;

				console.error(e);
			}
		},

		getIP: async function ()
		{
			try
			{
				var oResp = await axios('https://api.ipify.org?format=json');

				return oResp.data.ip;
			}
			catch (e)
			{
				console.error(e);

				return e;
			}
		}
	}
}
</script>

<style lang="scss">
.form-signup
{
	padding: 55px 15px;
	text-align: center;
	border-radius: 36px;
	
	&--short
	{
		background-color: #FFF;
	}

	&--long
	{
		background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFF 100%);

		@media (min-width: 576px)
		{
			padding-top: 70px;
			padding-bottom: 70px;
			padding-left: 5%;
			padding-right: 5%;
		}

		@media (min-width: 992px)
		{
			.form__inner
			{
				max-width: 1280px;
			}
		}
	}

	.textfield
	{
		padding-left: 75px;
		background-repeat: no-repeat;
		background-position: 30px center;

		&[name='name']
		{
			background-image: url('../assets/icon-user.svg');
		}

		&[name='email']
		{
			background-image: url('../assets/icon-mail.svg');
		}
	}
}

.form
{
	&__inner
	{
		margin: auto;
	}

	&__text
	{
		max-width: 315px;
		margin: 0 auto 40px;
	}

	&__logo
	{
		margin-bottom: -5px;
	}

	&__title
	{
		margin-bottom: 35px;
		line-height: 1.15;
		font-size: 3.5rem;
		font-weight: 700;
		color: #414042;

		span
		{
			color: #204687;
		}
	}

	&__submit
	{
		margin-top: 15px;
	}

	@media (min-width: 576px)
	{
		&__title
		{
			font-size: 4.6rem;
		}

		&__submit
		{
			margin-top: 35px;
		}
	}

	@media (min-width: 768px)
	{
		&__inner
		{
			max-width: 600px;
		}

		&__title
		{
			font-size: 5.6rem;
		}
	}

	@media (min-width: 992px)
	{
		&__text
		{
			margin-right: 25px;
			margin-bottom: 0;
			text-align: left;
		}
	}
}
</style>
